export default __webpack_public_path__ + "static/media/black_dragon.e869210a.png";